module.exports = __webpack_public_path__ + "static/media/ig19.2684b795.jpg";